"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LECOFFREIO_PROD_LEGACY_PUBLIC_HOST = exports.DEPLOYMENT_REMOTE_APP_ROOT_BASE = void 0;
exports.resolvePublicWebHostname = resolvePublicWebHostname;
exports.resolveCertificateHeaderTitles = resolveCertificateHeaderTitles;
exports.resolveWatermarkSourceLabel = resolveWatermarkSourceLabel;
exports.resolveDocumentationAncrageUrl = resolveDocumentationAncrageUrl;
exports.resolveRemoteAppRootPath = resolveRemoteAppRootPath;
exports.listRemoteAppRootCandidates = listRemoteAppRootCandidates;
const deploymentSiteCodes_1 = require("./deploymentSiteCodes");
const PUBLIC_WEB_HOST_RESOLVERS = {
    [deploymentSiteCodes_1.DEPLOYMENT_SITE_LECOFFREIO]: (env) => (env === "prod" ? "www.app.lecoffre.io" : `${env}.lecoffreio.4nkweb.com`),
};
function resolvePublicWebHostname(siteSlug, env) {
    const resolver = PUBLIC_WEB_HOST_RESOLVERS[siteSlug];
    if (resolver) {
        return resolver(env);
    }
    return `${env}.${siteSlug}.4nkweb.com`;
}
const CERTIFICATE_HEADER_BY_SLUG = {
    lecoffreio: { title: "LeCoffre.io", subtitle: "Plateforme notariale sécurisée" },
};
function resolveCertificateHeaderTitles(siteSlug) {
    const row = CERTIFICATE_HEADER_BY_SLUG[siteSlug];
    if (row) {
        return row;
    }
    const title = siteSlug.length > 0 ? `${siteSlug.charAt(0).toUpperCase()}${siteSlug.slice(1).toLowerCase()}` : "LeCoffre.io";
    return { title, subtitle: "Plateforme documentaire sécurisée" };
}
function resolveWatermarkSourceLabel(siteSlug, env) {
    if (siteSlug === deploymentSiteCodes_1.DEPLOYMENT_SITE_LECOFFREIO && env === "prod") {
        return "lecoffre.io";
    }
    return resolvePublicWebHostname(siteSlug, env);
}
function resolveDocumentationAncrageUrl(siteSlug, env) {
    if (siteSlug === deploymentSiteCodes_1.DEPLOYMENT_SITE_LECOFFREIO) {
        return "https://docs.lecoffre.io/ancrage";
    }
    return `https://${resolvePublicWebHostname(siteSlug, env)}/docs/ancrage`;
}
exports.DEPLOYMENT_REMOTE_APP_ROOT_BASE = "/srv/4NK";
exports.LECOFFREIO_PROD_LEGACY_PUBLIC_HOST = "prod.lecoffreio.4nkweb.com";
function resolveRemoteAppRootPath(siteSlug, env) {
    return `${exports.DEPLOYMENT_REMOTE_APP_ROOT_BASE}/${resolvePublicWebHostname(siteSlug, env)}`;
}
function listRemoteAppRootCandidates(siteSlug, env) {
    const canonical = resolveRemoteAppRootPath(siteSlug, env);
    if (env === "prod" && siteSlug === deploymentSiteCodes_1.DEPLOYMENT_SITE_LECOFFREIO) {
        const legacy = `${exports.DEPLOYMENT_REMOTE_APP_ROOT_BASE}/${exports.LECOFFREIO_PROD_LEGACY_PUBLIC_HOST}`;
        if (legacy !== canonical) {
            return [canonical, legacy];
        }
    }
    return [canonical];
}
